import { render, staticRenderFns } from "./ThreePartGallery.vue?vue&type=template&id=67aa860e&scoped=true"
import script from "./ThreePartGallery.vue?vue&type=script&lang=js"
export * from "./ThreePartGallery.vue?vue&type=script&lang=js"
import style0 from "./ThreePartGallery.vue?vue&type=style&index=0&id=67aa860e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa860e",
  null
  
)

export default component.exports